/**
 * KpiTiles + StageGridCard — tiles KPI e griglia stage cliccabile.
 * ★ Fase 59.P2 — estratto da DashboardPage.jsx. Comportamento e testid invariati.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '../ui/card';
import { ACCENT_TILE_STYLE } from './dashboardUtils';

export function KpiTiles({ tiles, gridClassName }) {
  return (
    <div className={gridClassName || 'grid grid-cols-2 lg:grid-cols-4 gap-3'}>
      {tiles.map((tile) => (
        <Card key={tile.label} className="border-border" data-testid="kpi-tile">
          <CardContent className="p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="text-[11px] uppercase tracking-wide text-muted-foreground">{tile.label}</div>
                <div className="font-serif text-3xl mt-1 text-[hsl(var(--primary))]">{tile.value || 0}</div>
                {tile.sub && (
                  <div className="text-[10px] text-muted-foreground mt-0.5">{tile.sub}</div>
                )}
              </div>
              <div className="w-9 h-9 rounded-lg grid place-items-center" style={ACCENT_TILE_STYLE}>
                <tile.icon className="w-4 h-4 text-[hsl(var(--accent-foreground))]" />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

// ★ 2026-07-29 — Stage Grid con TUTTI gli stage cliccabili (filtro Lead)
export function StageGridCard({ stages, agentFilter }) {
  const { t } = useTranslation();
  return (
    <Card className="border-border">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3">
          <div>
            <div className="text-[11px] uppercase tracking-wide text-muted-foreground">{t('dashboard.pipelineLive', 'Pipeline live')}</div>
            <div className="font-medium">{t('dashboard.leadsByStage', 'Lead per stage (clicca per aprire la lista filtrata)')}</div>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2" data-testid="stage-grid">
          {(stages || []).map((s) => {
            const count = s.count || 0;
            const cumulative = s.cumulative || 0;
            return (
              <Link
                key={s.key}
                to={`/app/leads?stage=${s.key}${agentFilter ? `&agent_id=${agentFilter}` : ''}`}
                className="border rounded-md p-2 hover:shadow-md hover:scale-[1.02] transition-all bg-white cursor-pointer block"
                style={{ borderLeftColor: s.color, borderLeftWidth: 3 }}
                data-testid={`stage-card-${s.key}`}
              >
                <div className="text-[10px] text-muted-foreground uppercase tracking-wide truncate">{s.short || s.label}</div>
                <div className="flex items-baseline gap-1.5">
                  <span className="text-xl font-semibold" style={{ color: s.color }}>{count}</span>
                  {cumulative > count && (
                    <span className="text-[10px] text-muted-foreground">({cumulative}↑)</span>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
        <div className="text-[10px] text-muted-foreground mt-2 italic">
          {t('dashboard.stagesLegend', 'Il numero grande = lead attualmente in questo stage · (N↑) = totale cumulativo (chi ha almeno raggiunto questo stage).')}
        </div>
      </CardContent>
    </Card>
  );
}
